import { FileText } from "lucide-react";
import { useRef, useState, useEffect } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

interface DocumentItemProps {
  fileBlob: Blob | null;
  index: number;
  isLoading?: boolean;
}

export const DocumentItem = ({
  index,
  fileBlob,
  isLoading = false,
}: DocumentItemProps) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [fileUrl, setFileUrl] = useState<string>("");
  const [fileType, setFileType] = useState<string>("");

  const imageRef = useRef<HTMLImageElement>(null);

  // Detectar tipo de arquivo e criar object URL
  useEffect(() => {
    if (fileBlob) {
      // Detectar tipo baseado no MIME type do blob
      const mimeType = fileBlob.type;
      setFileType(mimeType);

      // Criar object URL para exibição
      const url = URL.createObjectURL(fileBlob);
      setFileUrl(url);

      // Cleanup function
      return () => {
        URL.revokeObjectURL(url);
      };
    }

    setFileUrl("");
    setFileType("");
  }, [fileBlob]);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!imageRef.current) return;

    const rect = imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setMousePosition({ x, y });
  };

  const handleMouseEnter = () => {
    setIsZoomed(true);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  // Verificar se é PDF baseado no MIME type
  const isPdf = fileType === "application/pdf";

  return (
    <div
      className="document-item-style"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="file-preview">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <p>Carregando arquivo...</p>
          </div>
        ) : fileBlob && fileUrl ? (
          <>
            {isPdf ? (
              <div
                style={{
                  transform: isZoomed ? "scale(2)" : "scale(1)",
                  transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                  transition: "transform 0.2s ease-out",
                  width: "100%",
                }}
                ref={imageRef}
              >
                <Document file={fileUrl} className="pdf">
                  <Page pageNumber={1} />
                </Document>
              </div>
            ) : (
              <>
                <img
                  src={fileUrl}
                  ref={imageRef}
                  alt=""
                  style={{
                    transform: isZoomed ? "scale(2)" : "scale(1)",
                    transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                    transition: "transform 0.2s ease-out",
                    width: "100%",
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <FileText size={25} />
            <p>Área de Visualização</p>
          </>
        )}
      </div>

      {/* <p>Passe o mouse sobre a imagem para ver o zoom</p> */}
    </div>
  );
};
